<div class="app-container">
  <loading-spinner [isLoading]="loading()" [classesString]="'top-50'"></loading-spinner>
  @if (queryUser.data()) {
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <page-header
        [icon]="'far-user-cog'"
        [title]="isCreating() ? 'user.new' : isUserProfile() ? 'user.profile' : 'user.edit'"
        [appendNoTranslationTitlePart]="!isCreating() && userForm?.value ? userForm?.value.email : ''"
      >
        @if (userForm.value) {
          <ng-container class="header-button">
            <btn
              [btnType]="'submit'"
              [classes]="['btn-first', 'float-right']"
              [btnDisabled]="loading()"
              [icon]="'far-check'"
              [label]="'save'"
              [title]="'save' | translate"
              [isLoading]="loading()"
              spinnerClassesString="spinner-white"
              [dataCyAttribute]="'save-user'"
            ></btn>
            @if (!isCreating() && (isUserProfile() || isUserPermitted(loggedInUser()))) {
              <app-modal-change-pass [userProfile]="queryUser.data()"></app-modal-change-pass>
            }
          </ng-container>
        }
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <form-row-select
                [label]="'settings.locale'"
                [options]="availableLanguages"
                [formGroup]="userForm"
                formControlName="locale"
              >
              </form-row-select>
              <form-row-input
                [label]="'firstname'"
                [formGroup]="userForm"
                formControlName="firstName"
                [icon]="'far-user'"
                [required]="userForm.get('firstName').errors !== null && userForm.get('firstName').errors.required"
                [requiredCssClass]="submitted() && formControls.firstName.errors"
                [dataCyAttribute]="'first-name'"
              ></form-row-input>
              <form-row-input
                [label]="'lastname'"
                [formGroup]="userForm"
                formControlName="lastName"
                [required]="userForm.get('lastName').errors !== null && userForm.get('lastName').errors.required"
                [requiredCssClass]="submitted() && formControls.lastName.errors"
                [icon]="'far-list'"
                [dataCyAttribute]="'last-name'"
              ></form-row-input>
              <form-row-input
                [label]="'phone'"
                [icon]="'far-phone'"
                [formGroup]="userForm"
                formControlName="phone"
                [dataCyAttribute]="'phone'"
              ></form-row-input>
              <form-row-input
                [label]="'email'"
                [icon]="'far-envelope'"
                [formGroup]="userForm"
                [inputType]="'email'"
                formControlName="email"
                [required]="userForm.get('email').errors !== null && userForm.get('email').errors.required"
                [requiredCssClass]="submitted() && formControls.email.errors"
                [dataCyAttribute]="'email'"
              ></form-row-input>
              @if (isCreating()) {
                <div class="flex-gap-0-5">
                  <!--              todo add to cypress tests -> show/ hide password  and pin-->
                  <form-row-input
                    class="flex-basis-100"
                    [label]="'password'"
                    [icon]="'far-lock'"
                    [formGroup]="userForm"
                    formControlName="plainPassword"
                    [required]="
                      userForm.get('plainPassword').errors !== null && userForm.get('plainPassword').errors.required
                    "
                    [requiredCssClass]="submitted() && formControls.plainPassword.errors"
                    [inputType]="'text'"
                    [dataCyAttribute]="'password'"
                  >
                  </form-row-input>
                  <!--                todo add to trans 'user.generate-password-btn'-->
                  <btn
                    class="margin-top-1-2"
                    (onEvent)="generatePassword()"
                    [classes]="['btn-first']"
                    [label]="'user.password.generate' | translate"
                    [dataCyAttribute]="'modal-customer-search-open'"
                  >
                  </btn>
                </div>
              }
              @if (!isCreating() && queryUser.data()?.id !== loggedInUser()?.id) {
                <form-row-checkbox
                  [label]="'user.is.active'"
                  [cursorPointer]="true"
                  [formGroup]="userForm"
                  formControlName="enabled"
                >
                </form-row-checkbox>
              }
              @if (
                isCreating() ||
                (!isCreating() && !isUserProfile()) ||
                (!isCreating() && isUserProfile() && isUserPermitted())
              ) {
                <div class="mt-1">
                  <label class="mb-0">{{ 'checkouts' | translate }}:</label>
                  <p style="color: red; font-size: 10px; width: 70%">
                    {{ 'user.checkouts.warning.1' | translate }}
                    <a class="version-link" href="https://kb.depoto.cz/uzivatelske-ucty" target="_blank">
                      {{ 'user.checkouts.warning.2' | translate }}
                    </a>
                  </p>
                  @for (checkout of queryCheckouts.data(); track checkout) {
                    <div class="mb-2">
                      <form-row-checkbox
                        [label]="checkout.name"
                        [cursorPointer]="true"
                        [model]="hasUserCheckout(userForm.value, checkout)"
                        (modelChange)="updateCheckout(checkout, $event)"
                      ></form-row-checkbox>
                    </div>
                  }
                </div>
              }
              <form-row-input
                [label]="'pin'"
                [icon]="'far-lock'"
                [formGroup]="userForm"
                formControlName="pin"
                [inputType]="'text'"
                [dataCyAttribute]="'password'"
              ></form-row-input>
            </div>
            @if (
              isCreating() ||
              (!isCreating() && !isUserProfile()) ||
              (!isCreating() && isUserProfile() && isUserPermitted())
            ) {
              <div class="col-sm-6">
                <label class="mb-0">{{ 'groups' | translate }}:</label>
                @for (group of queryUserGroupsOptions.data(); track group) {
                  <div class="mb-2">
                    @if (group.roles?.length) {
                      <div class="flex-gap-0-5">
                        <form-row-checkbox
                          [label]="group.name"
                          [cursorPointer]="true"
                          [model]="isUserInGroup(userForm.value, group)"
                          (modelChange)="updateGroup(group, $event)"
                          [inputDisabled]="group.name === 'Admin' ? isNonAdminGroupSelected() : isAdminGroupSelected()"
                        ></form-row-checkbox>
                        <div
                          class="rolling-content-btn align-self-center"
                          (click)="rolesVisibilityChange(group)"
                          (keyup)="rolesVisibilityChange(group)"
                          role="button"
                          tabIndex="0"
                          aria-disabled="true"
                        >
                          <div class="flex-gap-5 align-items-center">
                            <i
                              [ngClass]="{ rotate: areGroupRolesVisible(group) }"
                              class="fa fa-chevron-down"
                              data-cy="filter"
                            ></i>
                            <div>
                              {{ (areGroupRolesVisible(group) ? 'group.hide.roles' : 'group.show.roles') | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (group.roles?.length && areGroupRolesVisible(group)) {
                      <span>
                        @for (role of group.roles; track role) {
                          <span class="badge bg-success me-2">
                            {{ role }}
                          </span>
                        }
                      </span>
                    }
                  </div>
                }
                @if (
                  isCreating() ||
                  (!isCreating() && !isUserProfile()) ||
                  (!isCreating() && isUserProfile() && isUserPermitted())
                ) {
                  <div class="mt-1">
                    <label class="mb-0">{{ 'depots' | translate }}:</label>
                    <p style="color: red; font-size: 10px; width: 70%">
                      {{ 'user.depots.warning.1' | translate }}
                      <a class="version-link" href="https://kb.depoto.cz/uzivatelske-ucty" target="_blank">
                        {{ 'user.depots.warning.2' | translate }}
                      </a>
                    </p>
                    @for (depot of queryDepotsOptions.data(); track depot) {
                      <div class="mb-2">
                        <form-row-checkbox
                          [label]="depot.name"
                          [cursorPointer]="true"
                          [model]="hasUserDepot(userForm.value, depot)"
                          (modelChange)="updateDepot(depot, $event)"
                        ></form-row-checkbox>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </section>
    </form>
  }
</div>
